import { $Locale } from '@lemon8/web-app-shared/atom';
import { Language } from '@lemon8/web-app-shared/i18n';
import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const $UserSelectedLanguage = atom<null, [Language], void>(null, (get, set, input: Language) => {
  const old = get($Locale);

  set($Locale, { ...old, language: input });
});

export const $SharePanel = atomWithReset<boolean>(false);
